module.exports = __webpack_public_path__ + "static/media/shirdi.de3e6928.jpg";